import React from 'react';
import NoData from 'components/_common/NoData';
import Loading from 'components/_common/Loading';
import SearchFilter from 'components/_common/SearchFilter';
import PageUtil from 'utils/Page.util';
import { PaginationControl } from 'react-bootstrap-pagination-control';
import { ReceptionItemKind, ReceptionStatus, getReceptionType, ReceptionType } from 'enums/reception.enum';

const TodayReceptionV = ({
    params,
    setParams,
    setSearch,
    onOpenEdit,
    onChangeStatus,
    handleExportExcel,
}) => {
    const { list, isLoaded, error } = params;



    return (
        <>
            {isLoaded && error == null ? (
                <>
                    <div className="content-header">
                        <h1>
                            <span>TODAY 접수</span>
                        </h1>
                    </div>

                    <div className="container-fluid">

                        {/* 고급 검색 필터 */}
                        <SearchFilter
                            searchParams={null}
                            onSearchChange={null}
                            onSearch={null}
                            onClearFilter={null}
                            onTodaySearch={null}
                            showStatusFilter={false}
                            showTypeFilter={false}
                            showDateRange={false}
                            showDateType={false}
                            dateTypeOptions={[]}
                            placeholder="고객명, 연락처, 지역 등 검색"
                            onExcelDownload={handleExportExcel}
                        />

                        {/* 목록 */}
                        <div className="card card-outline card-dark">
                            <div className="card-header">
                                <div className="card-title">TODAY 접수 목록</div>
                                <div className="card-tools">
                                    <span className="badge bg-secondary">
                                        {PageUtil.formatToKRW(params.total)} 건
                                    </span>
                                </div>
                            </div>
                            <div className="card-body table-responsive p-0">
                                {list.length === 0 ? (
                                    <NoData />
                                ) : (
                                    <table className="table  text-nowrap">
                                        <thead>
                                            <tr>
                                                <th style={{ minWidth: 120 }}>처리상황</th>
                                                <th>처리유형</th>
                                                <th>접수일자</th>
                                                <th>연락처</th>
                                                <th>고객명</th>
                                                <th>도</th>
                                                <th>지역</th>
                                                <th>보일러명</th>
                                                <th>제조년월</th>
                                                <th>특이사항</th>
                                                <th>접수내용</th>
                                                <th>처리내용</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {list.map((row) => (
                                                <tr key={row.id} style={row.blacklist ? { backgroundColor: '#ffe6e6' } : {}}>
                                                    <td>
                                                        <select
                                                            className="form-select form-select-sm"
                                                            value={row.status || ''}
                                                            onChange={(e) => onChangeStatus(row, e.target.value)}
                                                            style={{
                                                                color: row.status === 'ARREARS' ? '#dc3545' : '',
                                                                fontWeight: row.status === 'ARREARS' ? 'bold' : '',
                                                                fontSize: row.status === 'ARREARS' ? '15px' : '',
                                                            }}
                                                        >
                                                            {params.statusSet.map((s) => (
                                                                <option key={s.value} value={s.value} style={{ textAlign: 'center' }}>
                                                                    {s.label}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </td>
                                                    <td>
                                                        <span
                                                            className={"badge " + (row.type == ReceptionType.NEW_EXCHANGE || row.type == ReceptionType.EXCHANGE ? ' bg-danger' : 'bg-info')}
                                                            style={{ fontSize: '15px', padding: '5px 10px' }} // 글자 크기와 여백 추가
                                                        >
                                                            {getReceptionType().find((t) => t.value === row.type)?.label || row.type}
                                                        </span>
                                                    </td>
                                                    <td style={{ fontSize: '15px', fontWeight: 'bold' }}>
                                                        {row.receivedDate || ''}
                                                    </td>
                                                    {/* <td>
                                                        <span className="badge bg-secondary">
                                                            {getPaymentMethod().find((p) => p.value === row.paymentMethod)?.label || row.paymentMethod}
                                                        </span>
                                                    </td> */}
                                                    <td>
                                                        <a onClick={() => onOpenEdit(row)} style={{ cursor: 'pointer' }}>
                                                            {row.phone1 || ''}
                                                        </a>
                                                    </td>
                                                    <td>
                                                        <strong>{row.customerName || ''}</strong>
                                                    </td>
                                                    <td>{row.province || ''}</td>
                                                    <td>{row.city || ''}</td>
                                                    <td>
                                                        <code>{(row.items?.find(p => p.kind === ReceptionItemKind.BOILER)?.modelName || '') + (row.items?.filter(p => p.kind === ReceptionItemKind.BOILER)?.length > 1 ? ' 外' : '')}</code>
                                                    </td>
                                                    <td>
                                                        <small>{row?.items?.find(p => p.manufactureMonth)?.manufactureMonth || ''}</small>
                                                    </td>
                                                    <td>
                                                        <small className="text-warning">
                                                            {row.items?.filter(p => p.note).map(p => p.note).join(', ') || ''}
                                                        </small>
                                                    </td>
                                                    <td>
                                                        <small>{row.requestNote && row.requestNote.length > 10
                                                            ? `${row.requestNote.substring(0, 10)}...`
                                                            : (row.requestNote || '')
                                                        }</small>
                                                    </td>
                                                    <td>
                                                        <small>{row.handleNote && row.handleNote.length > 10
                                                            ? `${row.handleNote.substring(0, 10)}...`
                                                            : (row.handleNote || '')
                                                        }</small>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>

                            {/* 페이징 */}
                            {list.length > 0 && (
                                <PaginationControl
                                    page={params.search.page}
                                    total={params.total}
                                    limit={params.search.rows}
                                    changePage={(page) => {
                                        const cur = PageUtil.deepCopy(params);
                                        cur.search.page = page;
                                        setParams(cur);
                                        setSearch(true);
                                    }}
                                    ellipsis={1}
                                />
                            )}
                        </div>
                    </div>
                </>
            ) : (
                <Loading />
            )}
        </>
    );
};

export default TodayReceptionV;